<template>
  <v-row justify="start">
    <v-dialog
      v-model="dialogInstruction"
      @click:outside="$emit('close')"
      scrollable
      max-width="400px"
    >
      <v-card class="rounded-max pa-5" v-if="data">
        <div class="d-flex justify-center mb-3">
          <img
            src="../../assets/img/Popup Alert-Information0.png"
            height="75px"
            alt=""
          />
        </div>
        <p class="text-center">{{ data.pertanyaan }}</p>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "dialogInstruction",

  props: ["dialogInstruction", "data"],

  methods: {},
};
</script>
<style scoped>
.no_decoration {
  text-decoration: none;
}
</style>
